import { css } from 'styled-components';

import { SternumTheme } from '@sternum/theme';
import { ButtonTheme } from '@sternum/ui';

import { Colors } from '../constants';

import { padding } from './shared';

// TODO: Implement dark mode when figma mocks will be ready

const borderRadius = 6;

export function darkPrimaryTheme(theme: SternumTheme): ButtonTheme.ButtonVariantTheme {
  return {
    ...ButtonTheme.primaryTheme(theme),
    backgroundColor: Colors.BrandBlueLight,
    textColor: Colors.BrandBlue,
    border: `1px solid ${Colors.BrandBlueLight}`,
    borderRadius: borderRadius,

    hoverBackgroundColor: Colors.BrandBlueLightest,
    hoverTextColor: Colors.BrandBlue,
    hoverBorder: `1px solid ${Colors.BrandBlueLightest}`,
    hoverBorderRadius: borderRadius,

    disabledBackgroundColor: Colors.GreyDarkest,
    disabledTextColor: Colors.Grey,
    disabledBorder: `1px solid ${Colors.GreyDarkest}`,
    disabledBorderRadius: borderRadius,

    padding,
    fontSize: 12,
    fontWeight: 600,
    focusColor: Colors.AquaMiddle,
    lineHeight: '20px',

    buttonCss: ({ size }) => css`
      max-height: ${size === 'large' ? '38px' : '34px'};
      min-width: 90px;
    `,

    leftIconContainerCss: css`
      margin-right: 8px;
    `,
    rightIconContainerCss: css`
      margin-left: 8px;
    `,
  };
}

export function darkSecondaryTheme(theme: SternumTheme): ButtonTheme.ButtonVariantTheme {
  return {
    ...ButtonTheme.secondaryTheme(theme),
    backgroundColor: Colors.Dark,
    textColor: Colors.White,
    border: `1px solid ${Colors.Dark}`,
    borderRadius: borderRadius,

    hoverBackgroundColor: Colors.BrandBlueLightest,
    hoverTextColor: Colors.BrandBlue,
    hoverBorder: `1px solid ${Colors.BrandBlue}`,
    hoverBorderRadius: borderRadius,

    disabledBackgroundColor: Colors.GreyDarkest,
    disabledTextColor: Colors.Grey,
    disabledBorder: 'none',
    disabledBorderRadius: borderRadius,

    padding,
    fontSize: 12,
    fontWeight: 600,
    focusColor: Colors.AquaMiddle,
    lineHeight: '20px',

    buttonCss: ({ size }) => css`
      max-height: ${size === 'large' ? '38px' : '34px'};
      min-width: 90px;
    `,

    leftIconContainerCss: css`
      margin-right: 8px;
    `,
    rightIconContainerCss: css`
      margin-left: 8px;
    `,
  };
}

export function darkTertiaryTheme(theme: SternumTheme): ButtonTheme.ButtonVariantTheme {
  return {
    ...ButtonTheme.tertiaryTheme(theme),
    backgroundColor: 'transparent',
    textColor: Colors.DarkerText,
    border: `1px solid ${Colors.GreyDarker}`,
    borderRadius: borderRadius,

    hoverBackgroundColor: Colors.Light,
    hoverTextColor: Colors.DarkerText,
    hoverBorder: `1px solid ${Colors.Light}`,
    hoverBorderRadius: borderRadius,

    disabledBackgroundColor: 'transparent',
    disabledTextColor: Colors.GreyDarkerMiddle,
    disabledBorder: `1px solid ${Colors.GreyDarkerMiddle}`,
    disabledBorderRadius: borderRadius,

    padding,
    fontSize: 12,
    fontWeight: 600,
    focusColor: Colors.AquaMiddle,
    lineHeight: '20px',

    buttonCss: ({ size }) => css`
      max-height: ${size === 'large' ? '38px' : '34px'};
      min-width: 90px;
    `,

    leftIconContainerCss: css`
      margin-right: 8px;
    `,
    rightIconContainerCss: css`
      margin-left: 8px;
    `,
  };
}

export function darkTextTheme(theme: SternumTheme): ButtonTheme.ButtonVariantTheme {
  return {
    ...ButtonTheme.textTheme(theme),
    backgroundColor: 'transparent',
    textColor: Colors.BrandPink,

    hoverBackgroundColor: 'transparent',
    hoverTextColor: Colors.BrandPinkDark,

    disabledBackgroundColor: 'transparent',
    disabledTextColor: Colors.GreyDarkerMiddle,

    padding: 0,
    fontSize: 12,
    fontWeight: 600,
    focusColor: Colors.AquaMiddle,
    lineHeight: '20px',

    buttonCss: ({ size }) => {
      if (size === 'large') {
        return css`
          font-size: 16px;
          line-height: 24px;
        `;
      }

      return css`
        font-size: 12px;
        line-height: 20px;
      `;
    },

    leftIconContainerCss: css`
      margin-right: 8px;
    `,
    rightIconContainerCss: css`
      margin-left: 8px;
    `,
  };
}

export function darkTextSecondaryTheme(theme: SternumTheme): ButtonTheme.ButtonVariantTheme {
  return {
    ...ButtonTheme.textTheme(theme),
    backgroundColor: 'transparent',
    textColor: Colors.BrandBlueLight,

    hoverBackgroundColor: 'transparent',
    hoverTextColor: Colors.White,

    disabledBackgroundColor: 'transparent',
    disabledTextColor: Colors.GreyDarkest,

    padding: 0,
    fontSize: 12,
    fontWeight: 600,
    focusColor: Colors.AquaMiddle,
    lineHeight: '20px',

    buttonCss: ({ size }) => {
      if (size === 'large') {
        return css`
          font-size: 16px;
          line-height: 24px;
        `;
      }

      return css`
        font-size: 12px;
        line-height: 20px;
      `;
    },

    leftIconContainerCss: css`
      margin-right: 8px;
    `,
    rightIconContainerCss: css`
      margin-left: 8px;
    `,
  };
}

export function darkErrorPrimaryTheme(theme: SternumTheme): ButtonTheme.ButtonVariantTheme {
  return {
    ...ButtonTheme.primaryTheme(theme),
    backgroundColor: Colors.BrandPink,
    textColor: Colors.White,
    border: 'none',
    borderRadius: borderRadius,

    hoverBackgroundColor: Colors.BrandPinkDark,
    hoverTextColor: Colors.White,
    hoverBorder: 'none',
    hoverBorderRadius: borderRadius,

    disabledBackgroundColor: Colors.GreyDarkerMiddle,
    disabledTextColor: Colors.White,
    disabledBorder: 'none',
    disabledBorderRadius: borderRadius,

    padding,
    fontSize: 12,
    fontWeight: 600,
    focusColor: Colors.AquaMiddle,
    lineHeight: '20px',

    buttonCss: ({ size }) => css`
      max-height: ${size === 'large' ? '38px' : '34px'};
      min-width: 90px;
    `,

    leftIconContainerCss: css`
      margin-right: 8px;
    `,
    rightIconContainerCss: css`
      margin-left: 8px;
    `,
  };
}

export function darkWidgetTheme(theme: SternumTheme): ButtonTheme.ButtonVariantTheme {
  return {
    ...ButtonTheme.primaryTheme(theme),
    backgroundColor: Colors.TheLightest,
    textColor: Colors.BrandBlue,
    border: `1px solid ${Colors.BrandBlueLight}`,
    borderRadius: borderRadius,

    hoverBackgroundColor: Colors.BrandBlueLightest,
    hoverTextColor: Colors.BrandBlueMiddle,
    hoverBorder: `1px solid ${Colors.BrandBlueLight}`,
    hoverBorderRadius: borderRadius,

    disabledBackgroundColor: Colors.TheLightest,
    disabledTextColor: Colors.GreyDarkerMiddle,
    disabledBorder: `1px solid ${Colors.BrandBlueLight}`,
    disabledBorderRadius: borderRadius,

    padding,
    fontSize: 12,
    fontWeight: 600,
    focusColor: Colors.AquaMiddle,
    lineHeight: '20px',

    buttonCss: css`
      height: 135px;
      width: 264px;
    `,

    leftIconContainerCss: css`
      margin-right: 8px;
    `,
    rightIconContainerCss: css`
      margin-left: 8px;
    `,
  };
}

export function SBOMDarkButtonTheme(theme: SternumTheme): ButtonTheme.ButtonTheme {
  return {
    primary: darkPrimaryTheme(theme),
    secondary: darkSecondaryTheme(theme),
    tertiary: darkTertiaryTheme(theme),
    text: darkTextTheme(theme),
    'text-secondary': darkTextSecondaryTheme(theme),
    'error-primary': darkErrorPrimaryTheme(theme),
    widget: darkWidgetTheme(theme),
  };
}
